module.exports = __webpack_public_path__ + "static/img/aepic-18.cb3d8b5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/aepic/aepic-18.jpg
// module id = MfJA
// module chunks = 51